export default "__VITE_ASSET__uIG1oOaX__"